import { Button, Text, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { RiLoader2Fill } from 'react-icons/ri'
import { useAppSelector } from 'src/redux/hooks'
import { translateLanguageQuestions } from 'src/view-models/Languages'

interface Props {
  id: number,
  name: String,
  code: string
}

const Translate: React.FC<Props> = ({ id, name, code }) => {
  const { profile: user,isLoading:isLoadingProfile } = useAppSelector((state) => state.profile)
  const toast = useToast()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  
  const translateTheQuestions = async () => {
    localStorage.setItem("is-translating", JSON.stringify({ id, name }))
    setIsLoading(true)
    try {
      await translateLanguageQuestions(id, toast)

    } finally {
      localStorage.removeItem("is-translating")
      setIsLoading(false)
    }
  }

  // tracking the changes in localStorage in real time
  useEffect(() => {
    const syncWithLocalStorage = () => {
      const isTranslating = localStorage.getItem("is-translating") ? true : false
      setIsLoading(isTranslating)
    }

    // Handle changes in the same tab
    const interval = setInterval(syncWithLocalStorage, 1000)

    // Handle changes in other tabs
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "is-translating") {
        syncWithLocalStorage()
      }
    }
    window.addEventListener("storage", handleStorageChange)

    // Cleanup on unmount
    return () => {
      clearInterval(interval)
      window.removeEventListener("storage", handleStorageChange)
    }
  }, [])


  return (
    <>
      {code !== "fr" ? (
        <Button
          w="100%"
          colorScheme="blue"
          onClick={translateTheQuestions}
          isDisabled={isLoading}
        >
          {isLoading ? <RiLoader2Fill size={20} className='animate-spin' /> : <Text>Traduire les questions</Text>}
        </Button>
      ) : null}
    </>
  )
}

export default Translate
